/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Base from './base'
import { popRootKey } from '../util.js'

export default class BulkEdit extends Base {
  get url () { return '/my/polls/multi_edit' }

  /*
   * Needed so that backbone doesn't think this model is persistent.
   * Without this it will do a PUT rather than a POST.
   */
  get idAttribute () { return '_id' }

  initialize (opts) {
    if (opts == null) { opts = {} }
    this.users = opts.users
    delete opts.users

    // We don't want this sent in the POST body.
    return this.unset('users')
  }

  parse (json) {
    // add the groups last after the groups have been set up
    let group, user
    for (const obj of Array.from(json.polls)) {
      const attrs = popRootKey(obj)
      user = this.users.get(attrs.owner_id)
      group = user.groups.get(attrs.group_id)

      if (user != null) {
        user.polls.add(obj, { merge: true, parse: true })
      }
    }

    for (const obj of Array.from(json.updated_groups)) {
      user = this.users.get(popRootKey(obj).owner_id)
      if (user != null) {
        user.groups.add(obj, { merge: true, parse: true })
      }
    }

    for (const obj of Array.from(json.new_groups)) {
      user = this.users.get(popRootKey(obj).owner_id)
      group = user != null ? user.groups.add(obj, { merge: true, parse: true }) : undefined

      // tell the view that this is already loaded
      group.markAsLoaded()
    }

    for (let obj of Array.from(json.deleted_groups)) {
      obj = popRootKey(obj)
      user = this.users.get(obj.owner_id)
      if (user != null) {
        user.groups.remove(user != null ? user.groups.get(obj.id) : undefined)
      }
    }

    return json
  }
}
